<template>
  <b-modal
    v-model="activAddDonation"
    centered
    title="المتبرعين"
    id="modal-donors"
    footer-class="removed"
    cancel-variant="outline-secondary"
    size="xl"
    no-close-on-backdrop
  >
    <validation-observer ref="editdonorsValidation">
      <b-form class="auth-login-form mt-2" @submit.prevent>
        <b-card-text>
          <b-list-group class="rounded">
            <b-list-group-item class="">
              <b-row class="">
                <b-col> اسم المتبرع </b-col>
                <b-col> مبلغ التبرع </b-col>
                <b-col> يظهر للعموم </b-col>
                <b-col> </b-col>
              </b-row>
            </b-list-group-item>
            <div>
              <alert
                massage="عذراً لا يوجد نتائج لعرضها"
                class="w-100"
                v-if="donors.length == 0 && !loadingDonors && !isAdding"
              ></alert>
            </div>
            <div
              class="text-info text-center px-5"
              style="margin: 30px"
              v-if="loadingDonors"
            >
              <b-spinner variant="info"></b-spinner> جاري التحميل...
            </div>
            <b-list-group-item v-else v-for="item in donors" :key="item.id">
              <b-row v-if="id_donors == item.id">
                <b-col cols="3">
                  <form-input
                    id="name"
                    label="الاسم"
                    rules="required"
                    v-model="name"
                  />
                </b-col>
                <b-col>
                  <form-mask
                    label="مبلغ التبرع"
                    id="number"
                    v-model="number"
                    :raw="false"
                    placeholder="10,000"
                    options="number"
                    rules="required"
                  />
                </b-col>
                <b-col>
                  <form-select
                    label="يظهر للعموم"
                    rules="required"
                    :reduce="(el) => el.value"
                    :getOptionLabel="(x) => x.title"
                    :options="optionsType"
                    v-model="selectType"
                  />
                </b-col>

                <b-col
                  class="justify-content-end d-flex pt-50 align-items-center"
                >
                  <b-button
                    @click="
                      isAdding = false;
                      id_donors = null;
                    "
                    variant="outline-secondary"
                    class=""
                  >
                    <feather-icon icon="XIcon" />
                    إلغاء
                  </b-button>
                  <save-btn
                    :loading="workingDonors"
                    class="ml-1"
                    variant="primary"
                    style="height: 40px"
                    @click="formSubmitEdit(item.id)"
                    type="submit"
                  >
                  </save-btn>
                </b-col>
              </b-row>

              <b-row class="align-items-center" v-else>
                <b-col>{{ item.name }}</b-col>
                <b-col>
                  {{ item.donated_amount.toLocaleString("en-US") }}
                </b-col>
                <b-col> {{ item.is_famous ? "نعم" : "لا" }}</b-col>
                <b-col class="justify-content-end d-flex">
                  <b-button
                    @click="
                      id_donors = item.id;
                      name = item.name;
                      number = item.donated_amount;
                      optionsType.value = item.is_famous;
                      isAdding = false;
                    "
                    variant="flat-primary"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <b-spinner
                    v-if="deleteLoading == item.id"
                    small
                    variant="danger"
                    class="mt-1"
                    style="margin-left: 12px; margin-right: 12px"
                  ></b-spinner>
                  <b-button
                    v-else
                    @click="
                      deleteLoading = item.id;
                      deleteDonor({
                        id: item.id,
                        campaign_id: campaign_id,
                        page: page,
                      }).then(() => {
                        deleteLoading = null;
                      });
                    "
                    variant="flat-danger"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item v-if="isAdding">
              <h5 class="mb-2 text-primary">إضافة متبرع</h5>
              <b-row>
                <b-col cols="3">
                  <form-input
                    id="name"
                    label="الاسم"
                    v-model="name"
                    rules="required"
                  />
                </b-col>
                <b-col>
                  <form-mask
                    label="مبلغ التبرع"
                    id="number"
                    v-model="number"
                    :raw="false"
                    placeholder="10,000"
                    options="number"
                    rules="required"
                  />
                </b-col>
                <b-col>
                  <form-select
                    label="يظهر للعموم"
                    rules="required"
                    :reduce="(el) => el.value"
                    :getOptionLabel="(x) => x.title"
                    :options="optionsType"
                    v-model="selectType"
                  />
                </b-col>

                <b-col
                  class="justify-content-end d-flex pt-50 align-items-center"
                >
                  <b-button
                    @click="isAdding = false"
                    variant="outline-secondary"
                    class=""
                  >
                    <feather-icon icon="XIcon" />
                    إلغاء
                  </b-button>
                  <save-btn
                    :loading="workingDonors"
                    class="ml-1"
                    variant="primary"
                    style="height: 40px"
                    @click="formSubmitCreate()"
                    type="submit"
                  >
                  </save-btn>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </b-card-text>

        <b-row class="px-1 d-flex justify-content-end">
          <b-button @click="unFilter()" variant="success">
            <feather-icon icon="PlusIcon" />
            <span> إضافة </span>
          </b-button>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
<script>
import FormSelect from "@/components/form-select";
import saveBtn from "@/components/loader-btn";
import {
  BModal,
  BForm,
  BButton,
  BFormGroup,
  BCol,
  BRow,
  BCardText,
  BListGroup,
  BListGroupItem,
  BSpinner,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";
import { mapActions, mapGetters } from "vuex";
import Alert from "@/components/Alert.vue";
import FormInput from "@/components/form-input/index.vue";
import vSelect from "vue-select";
import FormMask from "@/components/form-mask";
export default {
  props: {
    value: Boolean,
    campaign_id: Number,
    page: Number,
  },
  components: {
    BSpinner,
    BListGroupItem,
    BListGroup,
    BModal,
    FormSelect,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BButton,
    BFormGroup,
    Cleave,
    BCol,
    BRow,
    BCardText,
    saveBtn,
    Alert,
    FormInput,
    vSelect,
    FormMask,
  },
  data: () => {
    return {
      isAdding: false,
      deleteLoading: false,
      id_donors: null,
      id_roul: null,
      start_date: "",
      end_date: "",
      number: null,
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      selectType: null,
      optionsType: [
        { value: 0, title: "لا" },
        { value: 1, title: "نعم" },
      ],
    };
  },
  methods: {
    formSubmitEdit(id) {
      this.$refs.editdonorsValidation.validate().then(async (success) => {
        if (success) {
          this.updateDonor(id);
        }
      });
    },

    formSubmitCreate() {
      this.$refs.editdonorsValidation.validate().then(async (success) => {
        if (success) {
          // this.addRouls();\
          this.addDonation();
        }
      });
    },
    ...mapActions("manageInterfaceNgo/ngoCampaign", [
      "getDonors",
      "addDonors",
      "updateDonors",
      "deleteDonor",
    ]),

    addDonation() {
      this.addDonors({
        data: {
          campaign_id: this.campaign_id,
          donated_type: true,
          is_famous: this.selectType,
          name: this.name,
          page: this.page,
          donated_amount: this.number.replace(/\D/g, ""),
        },
      }).then(() => {
        this.isAdding = false;
      });
    },

    updateDonor(id) {
      this.updateDonors({
        id: id,
        data: {
          campaign_id: this.campaign_id,
          donated_type: true,
          is_famous: true,
          name: this.name,
          page: this.page,
          donated_amount: this.number.replace(/\D/g, ""),
        },
      });
    },

    unFilter() {
      this.isAdding = true;
      this.donated_type = null;
      this.name = "";
      this.number = null;
      this.id_donors = null;
    },
  },
  watch: {
    campaign_id(val) {
      this.getDonors({ id: val });
    },
  },

  computed: {
    ...mapGetters("manageInterfaceNgo/ngoCampaign", [
      "donors",
      "loadingDonors",
      "workingDonors",
    ]),
    activAddDonation: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  created() {},
};
</script>

<style scoped></style>

<!-- methods: {
  formSubmitCreate() {
    this.$refs.addDonationValidation.validate().then(async (success) => {
      if (success) {
        this.addDonation();
        this.activAddDonation=false;
      }
    });
  },

  addDonation() {
    this.$store.dispatch(`manageInterfaceNgo/ngoCampaign/addDonors`, {
      campaign_id: this.campaign_id,
      donated_type:this.type.value ,
      is_famous:this.type.value,
      name: this.name,
      donated_amount: this.number,
    });
  },
},
computed: {
  activAddDonation: {
    set(val) {
      this.$emit("input", val);
    },
    get() {
      return this.value;
    },
  },
}, -->
